import type { FontOption } from '@/contexts/font-contexts'

export const AVAILABLE_FONTS: FontOption[] = [
  {
    name: 'Geist',
    value: 'Geist, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Montserrat',
    value: 'Montserrat, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Inter',
    value: 'Inter, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Roboto',
    value: 'Roboto, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Open Sans',
    value: 'Open Sans, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Lato',
    value: 'Lato, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Poppins',
    value: 'Poppins, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Source Sans Pro',
    value: 'Source Sans Pro, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Ubuntu',
    value: 'Ubuntu, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Nunito',
    value: 'Nunito, sans-serif',
    category: 'sans-serif',
  },
  {
    name: 'Work Sans',
    value: 'Work Sans, sans-serif',
    category: 'sans-serif',
  },
]
